module.exports = __webpack_public_path__ + "img/galeria-especie-mar4.2a46784d.jpg";